import React, { FunctionComponent } from 'react';
import { SelectField, SelectFieldProps, useRecordContext } from 'react-admin';

interface SelectChoiceFieldProps extends Omit<SelectFieldProps, 'choices'> {
  status_list?: Array<{ id: string | number; name: string }>;
}

const SelectChoiceField: FunctionComponent<SelectChoiceFieldProps> = (
  props
) => {
  const { source, status_list = [], ...restProps } = props;
  const record = useRecordContext();

  const choicesWithDisabled = status_list.map((choice) =>
    choice.id === 'proforma' &&
    (record?.status === 'created' || record?.status === 'payed')
      ? { ...choice, name: `${choice.name} (disabled)` }
      : choice
  );

  return (
    <SelectField source={source} choices={choicesWithDisabled} {...restProps} />
  );
};

export default SelectChoiceField;
